import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Button from './Button'
import Card from './Card'
import SweetAlertSuccess from './SweetAlertSuccess'

const SuccessConfirmation = ({ message, subMessage, onBack }: any) => (
  <Card>
    <Card.Content>
      <div style={{ marginTop: '40px' }}>
        <SweetAlertSuccess message={message} subMessage={subMessage} />
      </div>
    </Card.Content>

    <Card.Footer>
      <Button color="primary" onClick={onBack}>
        <FormattedMessage id="OK" defaultMessage="OK" />
      </Button>
    </Card.Footer>
  </Card>
)

SuccessConfirmation.displayName = 'SuccessConfirmation'

SuccessConfirmation.propTypes = {
  onBack: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  subMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}
SuccessConfirmation.defaultProps = {
  subMessage: ''
}

export default SuccessConfirmation
